import { render, staticRenderFns } from "./input-service-type.vue?vue&type=template&id=201ee767&"
import script from "./input-service-type.vue?vue&type=script&lang=js&"
export * from "./input-service-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports